/**
 * Queued - is a custom SVG Icon that displays when an icon in the Grid Status column.
 */
import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const Queued = createSvgIcon(
  <>
    <g>
      <rect fill="none" height="24" width="24" />
    </g>
    <g>
      <path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" />
    </g>
  </>,
  'Queued'
);
